import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HeaderSearchInput from "./components/HeaderSearchInput";
import elementService from "@/common/ElementService";

export default new class EshopHeaderSearchInputService {
    public init(initialSearchQuery: string, trackerId: string, hostname: string): void {
        const queryClient = new QueryClient();

        createRoot(elementService.querySelector<HTMLDivElement>("#js-search-box-container")).render(
            <QueryClientProvider client={queryClient}>
                <HeaderSearchInput initialSearchQuery={initialSearchQuery} trackerId={trackerId} hostname={hostname} />
            </QueryClientProvider>,
        );
    }
}();
